import _extends from "@babel/runtime/helpers/extends";
import { UrlUtils } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { discoverAppDetailsRoute, discoverRoute, manageAppDetailsRoute, manageAppRequestsRoute, managePromotionsRoute, manageRoute, searchRoute } from '../../constants/Routes';
import { getEmceeLocation } from '../../services/AP';
import { isEmceeConnect } from '../../utils/package-connect-utils';
import { useMountPath } from '../AppContext';
const enduserDiscoverPath = '/enduser-discover';
const adminDiscoverPath = '/discover';
/**
 * Central utility for constructing internal links to Emcee pages from anywhere, to anywhere
 */
const useEmceeLinks = () => {
  const mountPath = useMountPath();
  const [emceeUrl, setEmceeUrl] = useState({
    baseURL: '',
    fullURL: ''
  });
  const resolvePathFromRoute = function resolvePathFromRoute(route, params) {
    let routeMountPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return UrlUtils.resolveUrlFromTemplateAndParameters({
      template: UrlUtils.transformRoutePathToUriTemplate({
        routePath: UrlUtils.joinPathNames([routeMountPath, route.path])
      }),
      parameters: params
    });
  };
  const resolveRelativePathFromRoute = (route, params) => resolvePathFromRoute(route, params, mountPath);
  useEffect(() => {
    getEmceeLocation(_ref => {
      let {
        baseURL,
        fullURL
      } = _ref;
      return setEmceeUrl({
        baseURL,
        fullURL
      });
    }, mountPath);
  }, []);
  const isOnEndUserRoute = emceeUrl.fullURL.endsWith(enduserDiscoverPath);
  const discoverPath = isOnEndUserRoute ? enduserDiscoverPath : adminDiscoverPath;
  return {
    discoverHome: {
      getRelative: () => resolveRelativePathFromRoute(discoverRoute),
      getAbsolute: () => isEmceeConnect() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute(discoverRoute)) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(discoverRoute))
    },
    search: {
      getRelative: () => resolveRelativePathFromRoute(searchRoute),
      getAbsolute: () => isEmceeConnect() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute(searchRoute)) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(searchRoute))
    },
    appListing: {
      getRelative: _ref2 => {
        let {
          appKey
        } = _ref2;
        return resolveRelativePathFromRoute(discoverAppDetailsRoute, {
          appKey
        });
      },
      getAbsolute: _ref3 => {
        let {
          appKey
        } = _ref3;
        return isEmceeConnect() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute(discoverAppDetailsRoute, {
          appKey
        })) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(discoverAppDetailsRoute, {
          appKey
        }));
      }
    },
    manageHome: {
      getRelative: () => resolveRelativePathFromRoute(manageRoute),
      getAbsolute: () => isEmceeConnect() ? "".concat(emceeUrl.baseURL, "/discover#!").concat(resolvePathFromRoute(manageRoute)) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(manageRoute))
    },
    manageAppDetails: {
      getRelative: _ref4 => {
        let {
          appKey
        } = _ref4;
        return resolveRelativePathFromRoute(manageAppDetailsRoute, {
          appKey
        });
      },
      getAbsolute: _ref5 => {
        let {
          appKey
        } = _ref5;
        return isEmceeConnect() ? "".concat(emceeUrl.baseURL, "/discover#!").concat(resolvePathFromRoute(manageAppDetailsRoute, {
          appKey
        })) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(manageAppDetailsRoute, {
          appKey
        }));
      }
    },
    manageAppRequests: {
      getRelative: () => resolveRelativePathFromRoute(manageAppRequestsRoute),
      getAbsolute: () => isEmceeConnect() ? "".concat(emceeUrl.baseURL, "/app-requests#!").concat(resolvePathFromRoute(manageAppRequestsRoute)) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(manageAppRequestsRoute))
    },
    managePromotions: {
      getRelative: () => resolveRelativePathFromRoute(managePromotionsRoute),
      getAbsolute: () => isEmceeConnect() ? "".concat(emceeUrl.baseURL, "/promotions#!").concat(resolvePathFromRoute(managePromotionsRoute)) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute(managePromotionsRoute))
    }
  };
};
export function withEmceeLinks(BaseComponent) {
  function HOCComponent(props) {
    const links = useEmceeLinks();
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      emceeLinks: links
    }));
  }
  return HOCComponent;
}
export default useEmceeLinks;